import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import animated from 'animate.css'
// import MetaInfo from 'vue-meta-info'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/common.css'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import wow from 'wowjs'
import './assets/css/animation.css'
const app = createApp(App)

// 路由跳转后返回到顶部
router.afterEach((to, from, next) => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})

// Vue.prototype.$wow=wow
app.config.globalProperties.$wow = wow
app.use(router)
app.use(animated)
app.use(ElementPlus)

// app.use(MetaInfo)
app.mount('#app')
